// Calendar Events API client
import { apiClient } from './client';
export const calendarEventsApi = {
    /**
     * Get all calendar events for a workspace
     */
    async getWorkspaceEvents(workspaceId) {
        return apiClient.get(`/api/Workspaces/${workspaceId}/CalendarEvents`);
    },
    /**
     * Get calendar events for a specific campaign
     * (Placeholder for future implementation)
     */
    async getCampaignEvents(workspaceId, campaignId) {
        return apiClient.get(`/api/Workspaces/${workspaceId}/Campaigns/${campaignId}/CalendarEvents`);
    },
    /**
     * Get calendar events for a specific web
     * (Placeholder for future implementation)
     */
    async getWebEvents(workspaceId, webId) {
        return apiClient.get(`/api/Workspaces/${workspaceId}/Webs/${webId}/CalendarEvents`);
    },
};
